'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import emptyFunction from 'react-utils/emptyFunction';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDropdownDivider from 'UIComponents/dropdown/UIDropdownDivider';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { EMPTY_ARRAY } from 'DesignData/lib/array';
import { FINDER_FOLDER_RENAME } from 'DesignData/actions/ActionTypes';
export default function withFileMenuActionsList(WrappedComponent) {
  class WithFileMenuActionsList extends PureComponent {
    constructor(...args) {
      super(...args);

      this.createOnClickHandler = callback => {
        return () => {
          callback();
          this.props.onClose();
        };
      };
    }

    renderButton(action) {
      const {
        actionHandlers,
        i18nOptions,
        i18nKey,
        permissions
      } = this.props;
      return /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": action,
        onClick: this.createOnClickHandler(actionHandlers[action]),
        disabled: !permissions[action],
        use: "link",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(action),
          options: i18nOptions
        })
      }, action);
    }

    renderActions() {
      const {
        actions,
        hasMarketplaceListing,
        permissions
      } = this.props;

      if (!actions || !actions.length) {
        return EMPTY_ARRAY;
      }

      const result = actions.reduce((options, actionsList, index) => {
        if (!actionsList || !actionsList.length) {
          return options;
        }

        const menuActions = actionsList.map(action => {
          if (action === FINDER_FOLDER_RENAME && !permissions[action] && hasMarketplaceListing) {
            return /*#__PURE__*/_jsx(UITooltip, {
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: 'DesignFinderUI.actions.ThemeMarketplaceListingWarning'
              }),
              children: this.renderButton(action)
            }, action);
          }

          return this.renderButton(action);
        });

        if (index > 0) {
          options.push( /*#__PURE__*/_jsx(UIDropdownDivider, {}, `action-divider-${index}`));
        }

        options.push(menuActions);
        return options;
      }, []);
      return result.length ? result : EMPTY_ARRAY;
    }

    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
        fileMenuActionsList: this.renderActions()
      }));
    }

  }

  WithFileMenuActionsList.propTypes = {
    actions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
    actionHandlers: PropTypes.object.isRequired,
    hasMarketplaceListing: PropTypes.bool,
    i18nOptions: PropTypes.object.isRequired,
    i18nKey: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    permissions: PropTypes.object
  };
  WithFileMenuActionsList.defaultProps = {
    actions: [],
    actionHandlers: {},
    permissions: {},
    i18nOptions: {},
    i18nKey: emptyFunction,
    onClose: emptyFunction
  };
  return WithFileMenuActionsList;
}